import { Component, ChangeDetectionStrategy, Input, OnInit, OnChanges, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { Client } from '../../../models/client/client.model';
@Component({
  selector: 'app-lineitems-popover',
 // templateUrl: './lineitems-popover.page.html',
  styleUrls: ['./lineitems-popover.page.scss'],
  template: `
  <ion-list lines="none">
    <ion-item tappable (click)="addProductClickHandler()">Add Product</ion-item>
    <ion-item tappable (click)="addServiceClickHandler()" *ngIf="client.id != null">Add Service</ion-item>
  </ion-list>
`,
changeDetection: ChangeDetectionStrategy.OnPush
})
export class LineitemsPopoverPage {

  @Input() client: Client

  constructor (
    //private navParams: NavParams,
    //private viewCtrl: ViewController
    private popoverCtrl: PopoverController
    ) {
    //this.client = this.navParams.get('client');
  }

  public addProductClickHandler () {
    //this.viewCtrl.dismiss('product');
    this.popoverCtrl.dismiss('product');
  }

  public addServiceClickHandler () {
   // this.viewCtrl.dismiss('service');
   this.popoverCtrl.dismiss('service');
  }

}
